import { WHATSAPP_NUMBER } from "./pricing";
import { QuoteResult, PRODUCT_TYPE_LABEL, MODALITY_LABEL, formatMXN } from "./calculator";
import { AppState } from "./state";

export function buildWhatsAppMessage(state: AppState, result: QuoteResult): string {
  const productType = state.productType ? PRODUCT_TYPE_LABEL[state.productType] : "";
  const modality = state.modality ? MODALITY_LABEL[state.modality] : "";

  const resultLine =
    result.kind === "automatic"
      ? `Estimado mostrado: ${formatMXN(result.amount)} (referencia inicial)`
      : "Estado: cotización con equipo de producción";

  const lines = [
    `Hola, soy ${state.name}. Quiero solicitar una propuesta formal de fotografía de producto.`,
    "",
    `Producto: ${productType}`,
    `Modalidad: ${modality}`,
    `Productos/SKU: ${state.productCount}`,
    `Fotografías por producto: ${state.photosPerProduct}`,
    `Total de imágenes: ${result.totalImages}`,
    resultLine,
    `Mi WhatsApp: ${state.whatsapp}`,
    "",
    "Quisiera que revisaran el alcance y me enviaran una cotización formal."
  ];

  return lines.join("\n");
}

export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * Must be called synchronously inside a user gesture handler (click/submit)
 * so mobile Safari does not block the popup. Opens exactly one window.
 */
export function openWhatsApp(state: AppState, result: QuoteResult): void {
  const url = buildWhatsAppUrl(buildWhatsAppMessage(state, result));
  window.open(url, "_blank", "noopener");
}
